import type { GA4AnalyticsEvent } from '@/domain/shared/types';
import { useCallback } from 'react';

export const useAnalytics = () => {
  function sendEvent<T = GA4AnalyticsEvent>(event: T) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }

  return {
    sendEvent: useCallback(sendEvent, []),
  };
};
